import { FormatMessageFunction } from '@spa/lib/i18n/common/FormatMessageFunction';
import { ProductReviewPhoto } from '@spa/generated/graphql/graphql';

type ReviewPhotoDescriptionFactoryDependencies = {
  formatMessage: FormatMessageFunction;
};

type ReviewPhotoDescriptionFactory = {
  getReviewPhotoDescription: (photo: ProductReviewPhoto, index: number, total: number) => string;
};

export function createReviewPhotoDescriptionFactory(
  dependencies: ReviewPhotoDescriptionFactoryDependencies
): ReviewPhotoDescriptionFactory {
  const { formatMessage } = dependencies;

  return {
    getReviewPhotoDescription: (
      photo: ProductReviewPhoto,
      index: number,
      total: number
    ): string => {
      const caption = photo.caption?.trim();

      return caption || formatMessage('customerPhotoAlt', { index: index + 1, total });
    }
  };
}
